module.exports = __webpack_public_path__ + "img/0-65.666f3d7f.jpg";